import React from 'react';

import { CloudProviders } from '@ariksa/cloud-account';
import { SensitivityCategory } from '@ariksa/data-scanning';
import { Box, Center, Stack } from '@chakra-ui/react';
import { customTheme } from 'theme';

import { getIcon, PageHeaderWithIcon } from 'components/DataDisplay';
import { CustomSpinner } from 'components/DataDisplay/Spinner/CustomSpinner';
import {
  AwsIcon,
  AzureIcon,
  BitbucketIcon,
  CriticalDataIcon,
  DocumentsIcon,
  GithubIcon,
  GitLabIcon,
  GoogleCloudIcon,
  IconTypes,
  PipelineIcon,
  ServiceTicketIcon,
  SnowflakeIcon,
  UserIcon,
} from 'components/Icons';

// Share the persisted tab key so selection and initial data loading stay in sync.
export const VISIBILITY_DATA_TAB_STORAGE_KEY = 'visibility_data_tab';

export const dataTableHeading = {
  Identities: 'Data Security',
  DataSources: 'Sensitive Sources',
  DataTypes: 'Data Types In Sources',
  DocumentTypes: 'Document Types',
  all: 'All Sources',
};

export const dataNavList = [
  {
    label: 'Source',
    options: [
      {
        label: 'Sensitive Sources',
        value: IconTypes.DataSources,
        icon: <CriticalDataIcon />,
      },
    ],
  },
  {
    label: 'Access',
    options: [
      {
        label: 'Identities',
        value: 'Identities',
        icon: <UserIcon />,
      },
    ],
  },
  {
    label: 'Data',
    options: [
      {
        label: 'Documents',
        value: 'DocumentTypes',
        icon: <DocumentsIcon />,
      },
      {
        label: 'Data Types',
        value: 'DataTypes',
        icon: <ServiceTicketIcon />,
      },
    ],
  },
  {
    label: 'Other',
    options: [
      {
        label: 'Scan Status',
        value: 'all',
        icon: <PipelineIcon />,
      },
    ],
  },
];

export const sensitiveCategories = [
  SensitivityCategory.Internal,
  SensitivityCategory.Restricted,
  SensitivityCategory.Confidential,
  SensitivityCategory.Public,
];

export const cloudOptions = [
  { label: 'AWS', value: 'AWS', icon: <AwsIcon />, key: CloudProviders.Aws },
  {
    label: 'Azure',
    value: 'AZURE',
    icon: <AzureIcon />,
    key: CloudProviders.Azure,
  },
  {
    label: 'GCP',
    value: 'GCP',
    icon: <GoogleCloudIcon />,
    key: CloudProviders.Gcp,
  },
  {
    label: 'Snowflake',
    value: 'Snowflake',
    icon: <SnowflakeIcon />,
    key: CloudProviders.Snowflake,
  },
  {
    label: 'GitLab',
    value: 'GitLab',
    icon: <GitLabIcon />,
    key: CloudProviders.Gitlab,
  },
  {
    label: 'GitHub',
    value: 'GitHub',
    icon: <GithubIcon />,
    key: CloudProviders.Github,
  },
  {
    label: 'Atlassian BitBucket',
    value: 'BitBucket',
    icon: <BitbucketIcon />,
    key: CloudProviders.Bitbucket,
  },
];

export const renderDataSecurityHeader = selectedTab => (
  <Box>
    <PageHeaderWithIcon
      label={dataTableHeading[selectedTab]}
      icon={getIcon(
        selectedTab === IconTypes.DataSources
          ? IconTypes.SensitiveData
          : selectedTab === 'Identities'
          ? IconTypes.IdentityAndAccess
          : selectedTab === 'DocumentTypes'
          ? IconTypes.Documents
          : selectedTab === 'all'
          ? IconTypes.AllFindings
          : IconTypes.ServiceTicket,
      )}
      reversed
      iconBgColor="primary"
    />
  </Box>
);

export const renderDataSecuritySummaryCount = (
  icon,
  count,
  label,
  isLoading = false,
  onClick = () => {},
  iconPadding = 0.5,
) => (
  <Stack
    w="full"
    spacing={4}
    onClick={onClick}
    cursor={!!onClick ? 'pointer' : 'default'}
  >
    <Center w="full" color="primary">
      <Center boxSize={8} p={iconPadding}>
        {icon}
      </Center>
    </Center>
    <Stack w="full" spacing={0}>
      <Center w="full" fontWeight={600}>
        {isLoading ? <CustomSpinner /> : count}
      </Center>
      <Center w="full" color={customTheme.colors.gray['300']}>
        {label}
      </Center>
    </Stack>
  </Stack>
);
